import React, { Component } from "react"
import Roulette from 'react-roulette-game'
import './style.css'
import {FlipModal} from './flipModal'
import Modal from 'react-modal';

export class Role extends Component {

    constructor(props) {
        super(props)
        this.state = {
            customStyles:{
                content : {
                  top                   : '50%',
                  left                  : '50%',
                  right                 : 'auto',
                  bottom                : 'auto',
                  marginRight           : '-50%',
                  transform             : 'translate(-50%, -50%)',
                  border                : '0px',
                  borderTop             : 'unset',
                  backgroundColor       : 'rgb(0, 0, 0, 0)'

                }
            },
            final: '',
            modalIsOpen: true,
            isFlipped: false,
            dare: ''

        }
        this.handleClick = this.handleClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModal = this.openModal.bind(this);
    }
    closeModal(){
        this.setState({modalIsOpen: false})
    }
    openModal() {
        this.setState({modalIsOpen:true});
    }
    handleClick(e) {
        e.preventDefault();
        this.setState(prevState => ({ isFlipped: !prevState.isFlipped }));
    }
    componentDidMount(){
        if(this.props.match.params.dare == 1) this.setState({dare: 'dare1'})
        if(this.props.match.params.dare == 2) this.setState({dare: 'dare2'})
        if(this.props.match.params.dare == 3) this.setState({dare: 'dare3'})
        if(this.props.match.params.dare == 4) this.setState({dare: 'dare4'})
    }

    componentDidUpdate(prevProps){
        if (this.props.match.params.dare != prevProps.match.params.dare) {
            this.setState({modalIsOpen:true})
            if(this.props.match.params.dare == 1) this.setState({dare: 'dare1'})
            if(this.props.match.params.dare == 2) this.setState({dare: 'dare2'})
            if(this.props.match.params.dare == 3) this.setState({dare: 'dare3'})
            if(this.props.match.params.dare == 4) this.setState({dare: 'dare4'})
        }

    }

    alertFinal(final){
        this.setState({isFlipped: true, final})
    }

    render() {
        var img_name = ''
        var img_back_name = ''
        var role_top = ''
        let role_top_check = 1
        if(this.props.match.params.dare == 1){
            img_name = 'wheel-turaanadaa'
            img_back_name='wall-turaanadaa.png'
            role_top= 'marker-turaanadaa.png'
            role_top_check = 1
        }
        if(this.props.match.params.dare == 2){
            img_name = 'wheel-elgeemedeerei'
            img_back_name='wall-elgeemedeerei.png'
            role_top= 'marker-elgeemedeerei.png'
            role_top_check = 2
        }
        if(this.props.match.params.dare == 3){
            img_name = 'wheel-ayultai'
            img_back_name='wall-ayultai.jpg'
            role_top= 'marker-ayultai.png'
            role_top_check = 3
        }
        if(this.props.match.params.dare == 4){
            img_name = 'wheel-tuluu'
            img_back_name='wall-tuluu.jpg'
            role_top= 'marker-tuluu.png'
            role_top_check = 4
        }
        const roulette_props = {
            roulette_img_on_highlight: require(`../../static/img/role/${img_name}.png`),
            prize_arr: [
              'yndoo',
              'tsenher',
              'tsenher',
              'nogoon',
              'nogoon',
              'ulaan',
              'ulaan',
              'tsenher',
              'tsenher',
              'nogoon',
              'nogoon',
              'tsenher',
              'tsenher',
              'ulaan',
              'ulaan',
              'yndoo',
              'tsenher',
              'tsenher',
              'nogoon',
              'nogoon',
              'ulaan',
              'ulaan',
              'tsenher',
              'tsenher',
              'nogoon',
              'nogoon',
              'ulaan',
              'ulaan',
            ],
            reset_text: "Дахин эхлэх",
            start_text: 'Эхлэх',
        }
        const {modalIsOpen, customStyles, } = this.state
        return (
            <div>


                <Modal
                isOpen={modalIsOpen}
                style={customStyles}
                contentLabel="Example Modal"
                onRequestClose={this.closeModal}
                >
                    <FlipModal isFlipped={this.state.isFlipped} final={this.state.final} dare={this.state.dare}></FlipModal>
                    <div className='role-modal'>
                        <img className="flip" src={require(`../../static/img/role/${img_back_name}`)}></img>
                        {
                            role_top_check == 1 ?
                            <img className="role-top-1" src={require(`../../static/img/role/${role_top}`)}></img> :
                            role_top_check == 2 ?
                            <img className="role-top-2" src={require(`../../static/img/role/${role_top}`)}></img> :
                            role_top_check == 3 ?
                            <img className="role-top-3" src={require(`../../static/img/role/${role_top}`)}></img> :
                            role_top_check == 4 ?
                            <img className="role-top-4" src={require(`../../static/img/role/${role_top}`)}></img> : null
                        }
                        <div className='game-box role-real'>
                            <Roulette {...roulette_props}
                                on_complete={(final) => this.alertFinal(final)}
                                start_callback={() => this.setState({isFlipped: false})}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        )

    }

}
